export default __webpack_public_path__ + "locales/ru/Files.json?hash=9712820e1fc1d8e0b33f0e0be53a8784";